var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Radar',{attrs:{"chart-options":_vm.options,"chart-data":_vm.chartData,"width":+_vm.width,"height":+_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }